import "../scss/style.scss";
import "./home.js";
import "./sustainability.js";
import objectFitImages from 'object-fit-images';
import 'jquery-match-height';
import 'lity';
import 'magnific-popup';

jQuery(function ($) {
  // smooth scroll
  if (matchMedia('(max-width: 767px)').matches) {
    var headerHeight = $('.header').outerHeight(true);
  } else {
    var headerHeight = 0;
  }
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function() {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }

  // SP menu
  $(function(){
    $('.js-nav-btn').on('click',function(){
      $(".nav__list").toggleClass('is_open');
      $(this).toggleClass('is-close');
    });
    $('.js-nav a[href^="#"]').on('click',function(){
      $(".nav__list").toggleClass('is_open');
      $('.js-nav-btn').removeClass('is-close');
    });
  });

  // ドロップダウン
  $(function () {
    var dropdown = $('.nav__btm__item');
    var dropdownItem = $('.nav__btmChild');
    var toggleClickA = $('.nav__btm__parent.is_arrow');
    if (matchMedia('(max-width: 767px)').matches) {
      toggleClickA.on('click', function () {
        $(this).toggleClass('is_open');
        $(this).closest(dropdown).find(dropdownItem).slideToggle();
      });
    } else {
      dropdown.on({"mouseenter": function(){
        $(this).find(dropdownItem).addClass('open');
      }, "mouseleave": function () {
        $(this).find(dropdownItem).removeClass('open');
      }});
    }
  });

  // pagetop
  $(function(){
    $(window).scroll(function () {
      if($(this).scrollTop() >= 300) {
        $('.js-pagetop').fadeIn();
      } else {
        $('.js-pagetop').fadeOut();
      }
    });
  });

  $(function () {
    objectFitImages('.js-objectfit-img');
  });

  // tab
  $(function() {
    $('.js-tab-btn').click(function() {
      var index = $(this).parent().children('.js-tab-btn').index(this);
      $(this).parent().children('.js-tab-btn').removeClass('is-active');
      $(this).addClass('is-active');
      $(this).parents('.js-tab-set').find('.js-tab-content').removeClass('is-show').eq(index).addClass('is-show');
    });
  });

  //tab切り替え
  $(function () {
    $('.js-tab li').click(function () {
      var index = $('.js-tab li').index(this);
      $('.js-tab li').removeClass('on');
      $(this).addClass('on');
      $('.js-area .js-area-box').removeClass('show').eq(index).addClass('show');
    });
  });

  // プルダウン
  $('.js-pullDown').on('click', function (event) {
    event.preventDefault();
    $(this).parent().toggleClass('is_open');
    $(this).next().slideToggle();
  });

  $(function(){
    $('.p-company__tagList >li').each(function(index,element){
      var w = $(element).width()
      $('.p-company__tagList').append('<li style="height:0; width:'+ w +'px; margin:0;"></li>')
    })
  })

  // scroll animation
  $(document).on('scroll', function () {
    jsFadeUp();
  });

  jsFadeUp();

  function jsFadeUp() {
    $('.js-fadeUp').each(function () {
    var targetElement = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > targetElement - windowHeight + 100){
      $(this).addClass('scrollin');
    }
    else {
    	$(this).removeClass('scrollin');
    }
		});
  }

    //  modal
  if ($('.popup__modal').length) {
    $('.popup__modal').magnificPopup({
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: true,
      closeOnBgClick: true,
      closeBtnInside: false,
      showCloseBtn: false,
    });
  }

  $(document).on('click', '.pageSupport05__modal__btn', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $(function(){
    $('.js-matchheight').matchHeight();
  });
});

// TOPへ戻る
$(function(){
  var retop = $(".retop");
  $(window).on('load scroll', function () {
    if($(this).scrollTop() >= 300) {
      retop.fadeIn();
    } else {
      retop.fadeOut();
    }
  });
});
